import { render, staticRenderFns } from "./classInfo.vue?vue&type=template&id=a4d5fa5a&scoped=true&"
import script from "./classInfo.vue?vue&type=script&lang=js&"
export * from "./classInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d5fa5a",
  null
  
)

export default component.exports